export default "<p>404 works!</p>\n<p>Voltar para a <a href=\"\">página inicial</a>.</p>\n";